export const isType234 = (input: number) =>
    [2, 3, 4].includes(Math.floor(input) % 10) && ![12, 13, 14].includes(Math.floor(input) % 100);
